/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CategoryProductFragment = {
  readonly __typename?: 'Product';
  readonly calories: number;
  readonly categoryId: string;
  readonly cost: number;
  readonly description: string;
  readonly id: string;
  readonly isModifiable: boolean;
  readonly isCustom: boolean;
  readonly customType: Types.CustomProductType | null;
  readonly isSalad: boolean;
  readonly name: string;
  readonly outOfStock: boolean;
  readonly restaurantId: string;
  readonly slug: string;
  readonly throttleItem: boolean;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  }>;
  readonly label: {
    readonly __typename?: 'ProductLabel';
    readonly id: string;
    readonly name: string;
  } | null;
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
};

export type CategoryFragment = {
  readonly __typename?: 'MenuCategory';
  readonly id: string;
  readonly name: string;
  readonly isCustom: boolean;
  readonly products: ReadonlyArray<{
    readonly __typename?: 'Product';
    readonly calories: number;
    readonly categoryId: string;
    readonly cost: number;
    readonly description: string;
    readonly id: string;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly customType: Types.CustomProductType | null;
    readonly isSalad: boolean;
    readonly name: string;
    readonly outOfStock: boolean;
    readonly restaurantId: string;
    readonly slug: string;
    readonly throttleItem: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
    readonly label: {
      readonly __typename?: 'ProductLabel';
      readonly id: string;
      readonly name: string;
    } | null;
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
  }>;
};

export type RestaurantMenuFragment = {
  readonly __typename?: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly address: string;
  readonly phone: string;
  readonly isOutpost: boolean;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly deliveryFee: number;
  readonly flexMessage: string | null;
  readonly hours: {
    readonly __typename?: 'RestaurantHours';
    readonly formatted: string | null;
  };
  readonly menu: {
    readonly __typename?: 'Menu';
    readonly id: string;
    readonly categories: ReadonlyArray<{
      readonly __typename?: 'MenuCategory';
      readonly id: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly products: ReadonlyArray<{
        readonly __typename?: 'Product';
        readonly calories: number;
        readonly categoryId: string;
        readonly cost: number;
        readonly description: string;
        readonly id: string;
        readonly isModifiable: boolean;
        readonly isCustom: boolean;
        readonly customType: Types.CustomProductType | null;
        readonly isSalad: boolean;
        readonly name: string;
        readonly outOfStock: boolean;
        readonly restaurantId: string;
        readonly slug: string;
        readonly throttleItem: boolean;
        readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
        }>;
        readonly label: {
          readonly __typename?: 'ProductLabel';
          readonly id: string;
          readonly name: string;
        } | null;
        readonly dietaryProperties: ReadonlyArray<{
          readonly __typename?: 'DietaryProperty';
          readonly id: string;
          readonly name: Types.DietaryPropertyKind;
        }>;
      }>;
    }>;
  };
};

export type RestaurantQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type RestaurantQuery = {
  readonly __typename?: 'Query';
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly address: string;
    readonly phone: string;
    readonly isOutpost: boolean;
    readonly isAcceptingOrders: boolean;
    readonly notAcceptingOrdersReason: string;
    readonly deliveryFee: number;
    readonly flexMessage: string | null;
    readonly hours: {
      readonly __typename?: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly menu: {
      readonly __typename?: 'Menu';
      readonly id: string;
      readonly categories: ReadonlyArray<{
        readonly __typename?: 'MenuCategory';
        readonly id: string;
        readonly name: string;
        readonly isCustom: boolean;
        readonly products: ReadonlyArray<{
          readonly __typename?: 'Product';
          readonly calories: number;
          readonly categoryId: string;
          readonly cost: number;
          readonly description: string;
          readonly id: string;
          readonly isModifiable: boolean;
          readonly isCustom: boolean;
          readonly customType: Types.CustomProductType | null;
          readonly isSalad: boolean;
          readonly name: string;
          readonly outOfStock: boolean;
          readonly restaurantId: string;
          readonly slug: string;
          readonly throttleItem: boolean;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly ingredients: ReadonlyArray<{
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          }>;
          readonly label: {
            readonly __typename?: 'ProductLabel';
            readonly id: string;
            readonly name: string;
          } | null;
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        }>;
      }>;
    };
  } | null;
};

export const CategoryProductFragmentDoc = gql`
  fragment CategoryProduct on Product {
    asset {
      url
    }
    calories
    categoryId
    cost
    description
    id
    ingredients {
      asset {
        url
      }
      id
      name
    }
    isModifiable
    isCustom
    customType
    isSalad
    label {
      id
      name
    }
    dietaryProperties {
      id
      name
    }
    name
    outOfStock
    restaurantId
    slug
    throttleItem
  }
`;
export const CategoryFragmentDoc = gql`
  fragment Category on MenuCategory {
    id
    name
    isCustom
    products {
      ...CategoryProduct
    }
  }
  ${CategoryProductFragmentDoc}
`;
export const RestaurantMenuFragmentDoc = gql`
  fragment RestaurantMenu on Restaurant {
    id
    slug
    name
    city
    state
    zipCode
    address
    phone
    isOutpost
    hours {
      formatted
    }
    isAcceptingOrders
    notAcceptingOrdersReason
    deliveryFee
    flexMessage
    menu {
      id
      categories {
        ...Category
      }
    }
  }
  ${CategoryFragmentDoc}
`;
export const RestaurantDocument = gql`
  query Restaurant($id: ID!) {
    restaurant(id: $id) {
      ...RestaurantMenu
    }
  }
  ${RestaurantMenuFragmentDoc}
`;

export function useRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<RestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RestaurantQuery, RestaurantQueryVariables>({
    query: RestaurantDocument,
    ...options,
  });
}
